import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {select} from "@angular-redux/store";
import {combineLatest, Observable, Subscription} from "rxjs";
import {IProjectTypeSelector} from "../../models/common";

@Component({
  selector: 'edsng-breadcrumb-selection',
  templateUrl: './breadcrumb-selection.component.html',
  styleUrls: ['./breadcrumb-selection.component.css']
})
export class BreadcrumbSelectionComponent implements OnInit, OnDestroy {
  @select(['appProjectTypes', 'breadcrumb'])  breadCrumb$: Observable<IProjectTypeSelector[]>;

  @Output() onSelectCollection: EventEmitter<IProjectTypeSelector> = new EventEmitter<IProjectTypeSelector>();

  constructor() { }

  ngOnInit() {}

  ngOnDestroy() {}

  isMenuActive(idx: number, item: IProjectTypeSelector): boolean {
    // if (idx === 0) { return false; } // skip menu in root item
    return item && item.nodes && item.nodes.some(x => x.catalog && x.classType && !x.url);
  }

  subNodesRunnuble(nodes: IProjectTypeSelector[]): IProjectTypeSelector[] {
    // list of subNodes collection enabled
    return nodes.filter(x => x.catalog && x.classType && !x.url);
  }

  selectCollectionItem(item: IProjectTypeSelector) {
    if (this.onSelectCollection) {
      this.onSelectCollection.emit(item);
    }
  }
}
